import * as React from "react";

import primaryColour from "../constants";

function FilledEvent(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.502 6C12.502 9.31371 9.81566 12 6.50195 12C3.18824 12 0.501953 9.31371 0.501953 6C0.501953 2.68629 3.18824 0 6.50195 0C9.81566 0 12.502 2.68629 12.502 6ZM6.82181 3.23074C6.82181 2.84839 6.51185 2.53844 6.1295 2.53844C5.74715 2.53844 5.43719 2.84839 5.43719 3.23074V5.99998C5.43719 6.38233 5.74715 6.69228 6.1295 6.69228H8.43719C8.81955 6.69228 9.1295 6.38233 9.1295 5.99998C9.1295 5.61762 8.81955 5.30767 8.43719 5.30767H6.82181V3.23074Z"
        fill={fill}
      />
    </svg>
  );
}

export default FilledEvent;
